/** @format */

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormikProps } from 'formik';
import * as React from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectConstants } from './Api/constantSlice';
import { DropdownDto } from './Api/Models';
import { ErrorBox } from '../custom/ErrorBox';

interface Props {
  formik: FormikProps<any>;
}
export default function TypeOfStudy({ formik }: Props) {
  const selConst = useAppSelector(selectConstants);
  return (
    <>
      {selConst.constantState.typeOfStudies && (
        <>
          <FormControl fullWidth disabled>
            <InputLabel
              error={
                formik.touched.typeOfStudyId &&
                Boolean(formik.errors.typeOfStudyId)
              }
              id='demo-select-small'>
              Type Of Study
            </InputLabel>
            <Select
              name='typeOfStudyId'
              labelId='demo-select-small'
              id='demo-select-small'
              value={formik.values.typeOfStudyId}
              label='Year Of Study'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.typeOfStudyId &&
                Boolean(formik.errors.typeOfStudyId)
              }>
              <MenuItem value={0} disabled>
                Select Type Of Study
              </MenuItem>
              {selConst.constantState.typeOfStudies.map(
                (data: DropdownDto, key: number) => {
                  return (
                    <MenuItem key={key} value={data.id}>
                      {data.description}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>

          <ErrorBox>
          {formik.touched.typeOfStudyId &&
              (formik.errors.typeOfStudyId as React.ReactNode)}
                                        </ErrorBox>
        </>
      )}
    </>
  );
}
